var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6464 12.9799L5.8535 9.18705C5.53852 8.87207 5.7616 8.3335 6.20706 8.3335H13.7928C14.2383 8.3335 14.4614 8.87207 14.1464 9.18705L10.3535 12.9799C10.1582 13.1752 9.84166 13.1752 9.6464 12.9799Z",
    fill: "#BF0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortArrow);
export default __webpack_public_path__ + "static/media/shortArrow.21ed7faafc4e0a7b56f08899d8c7550c.svg";
export { ForwardRef as ReactComponent };